const PhoneList = r => require.ensure([], () => r(require('./PhoneList.vue')), 'shared')

export default PhoneList
